import React from 'react';
import Input from '../Input/Input.js';
import standardInput from '../hocs/StandardInputHOC.js';
function StandardPhoneInput(props) {
  return /*#__PURE__*/React.createElement(Input, Object.assign({
    "data-cmp": "standardPhoneInput",
    type: "tel",
    label: "Phone",
    mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  }, props));
}
export default /* #__PURE__ */standardInput(StandardPhoneInput, {
  validations: {
    matchRegexp: /^[(]\d\d\d[)]\s\d\d\d[-]\d\d\d\d/
  },
  validationError: 'Enter a valid phone number',
  validationErrors: {
    isDefaultRequiredValue: 'Enter a phone number'
  }
});